<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>تنظیمات اشتراک</h4>
          </div>
          <div class="widget-body">
            <form id="licenseForm" class="form-horizontal">
              <!-- license name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">چک کردن برای همه</label>
                <div class="col-lg-6">
                  <select class="form-control" name="" v-model="setting.forAll" id="">
                    <option value="active">فعال</option>
                    <option value="deactive">غیر فعال</option>
                    <option value="specific">بر اساس پلتفرم</option>
                  </select>
                </div>
              </div>
              <div v-if="setting.forAll == 'specific'">
                <div class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">چک کردن برای اندروید</label>
                  <div class="col-lg-6">
                    <select class="form-control" v-model="setting.forAllAndroid" name="" id="">
                      <option value="active">فعال</option>
                      <option value="deactive">غیر فعال</option>
                      <option value="specific">بر اساس ورژن</option>
                    </select>
                  </div>
                </div>

                <!-- license price -->
                <div v-if="setting.forAllAndroid == 'specific'" class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                    >بیلد نامبر های مجانی را با , جدا کنید</label
                  >
                  <div class="col-lg-6">
                    <input
                      type="text"
                      name="force"
                      class="form-control"
                      min="1"
                      v-model="setting.freeAndroidBuildNumbers"
                    />
                  </div>
                </div>

                <div class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">چک کردن برای ios</label>
                  <div class="col-lg-6">
                    <select class="form-control" v-model="setting.forAllIos" name="" id="">
                      <option value="active">فعال</option>
                      <option value="deactive">غیر فعال</option>
                      <option value="specific">بر اساس ورژن</option>
                    </select>
                  </div>
                </div>

                <!-- license price -->
                <div v-if="setting.forAllIos == 'specific'" class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                    >بیلد نامبر های مجانی را با , جدا کنید</label
                  >
                  <div class="col-lg-6">
                    <input
                      type="text"
                      name="force"
                      class="form-control"
                      min="1"
                      v-model="setting.freeIosBuildNumbers"
                    />
                  </div>
                </div>

                <div class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">حالت پایه</label>
                  <div class="col-lg-6">
                    <input type="checkbox" v-model="setting.defualt" name="" id="" />
                    <p>
                      <span v-if="setting.defualt" class="text text-success">فعال</span>
                      <span v-else class="text text-danger">غیر فعال</span> در صورتی که هیچکدام از وضعیت های فوق برای
                      کاربر صدق نکند
                    </p>
                  </div>
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/licenses">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import settingService from '../../../../services/license';
export default {
  name: 'licenseSetting',
  data() {
    return {
      setting: {},
    };
  },
  created() {
    this.getSetting();
  },
  methods: {
    async getSetting() {
      try {
        const setting = await settingService.getLicenseSetting();
        this.setting = setting;
        console.log(setting);
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      try {
        await settingService.setLicenseSetting(this.setting);
        this.getSetting();
        window.notif({ isError: false, mssg: 'اپدیت شد' });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
